import Skeleton from '@mui/material/Skeleton';
/**
 * Pigment [Skeleton](https://pigment.customink.com/?path=/docs/components-skeleton)
 */
export default Skeleton;
//# sourceMappingURL=Skeleton.js.map